import React from "react";
import { DataProductList } from "../data_products/DataProductList"
import useCustomTable from "../tables/useCustomTable";

export default function DataVendorAudiences({onRowClick, audiences, onAdd, newButtonContent}) {

  const columns = [{
    Header: 'Name',
    accessor: 'name'
  },{
    Header: 'Data Type',
    accessor: 'data_type'
  }];

  const {
    tableProps,
    paginationProps,
    tableSearchProps
  } = useCustomTable({
    sortable: true,
    paginate: true
  })

  const dataProductListOptions = {
    onRowClick,
    columns,
    tableProps,
    paginationProps,
    tableSearchProps,
    onAdd,
    newButtonContent
  }

  return (
    <DataProductList {...dataProductListOptions} data={audiences} />
  )
}
